// Cheap layout reads for per-frame toys: a rect is re-measured at most every MAX_AGE ms,
// or sooner after any scroll/resize anywhere (scroll is caught in the capture phase, so
// inner scrollers like .gj-scroll count too).
const MAX_AGE = 250;
let epoch = 0;
let listening = false;
const bump = () => { epoch++; };

function listen() {
  if (listening || typeof window === 'undefined') return;
  listening = true;
  window.addEventListener('scroll', bump, { passive: true, capture: true });
  window.addEventListener('resize', bump, { passive: true });
}

export function layoutEpoch(): number { return epoch; }

export class RectCache {
  rect: DOMRect | null = null;
  private at = -1e9;
  private ep = -1;
  constructor(private el: () => Element | null) { listen(); }
  // `soon`: after a scroll, re-measure right away (pointer moved) instead of waiting out MAX_AGE.
  get(now: number, soon = false): DOMRect | null {
    const el = this.el();
    if (!el) return null;
    const stale = now - this.at >= MAX_AGE || (soon && this.ep !== epoch);
    if (!this.rect || stale) { this.rect = el.getBoundingClientRect(); this.at = now; this.ep = epoch; }
    return this.rect;
  }
  invalidate() { this.rect = null; }
}

export function nearRect(r: DOMRect, x: number, y: number, pad: number): boolean {
  return x >= r.left - pad && x <= r.right + pad && y >= r.top - pad && y <= r.bottom + pad;
}
